/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "eu-central-1",
  aws_appsync_graphqlEndpoint: "https://4brh5wu5yfax3ltecujnkjvmym.appsync-api.eu-central-1.amazonaws.com/graphql",
  aws_appsync_region: "eu-central-1",
  aws_appsync_authenticationType: "AWS_IAM",
  aws_cloud_logic_custom: [
    {
      name: "UserPoolApi",
      endpoint: "https://bolusc2so5.execute-api.eu-central-1.amazonaws.com/enrx",
      region: "eu-central-1",
    },
  ],
  aws_cognito_identity_pool_id: "eu-central-1:0e4b132a-3ad1-4e74-b7f2-e8b532139b06",
  aws_cognito_region: "eu-central-1",
  aws_user_pools_id: "eu-central-1_38EFyoju8",
  aws_user_pools_web_client_id: "1bmctcgisvfpqvleb05sb10dln",
  oauth: {},
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
  aws_user_files_s3_bucket: "efd-media-store140105-enrx",
  aws_user_files_s3_bucket_region: "eu-central-1",
};

export default awsmobile;
